import { render } from "./ProductFixationCollection.vue?vue&type=template&id=cfd1c0b0&scoped=true"
import script from "./ProductFixationCollection.vue?vue&type=script&lang=js"
export * from "./ProductFixationCollection.vue?vue&type=script&lang=js"

import "./ProductFixationCollection.vue?vue&type=style&index=0&id=cfd1c0b0&lang=scss&scoped=true"

import exportComponent from "G:\\ElectronicPointOfSales\\Mang.EposApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfd1c0b0"]])

export default __exports__